import { Autocomplete, Box, Button, Card, CardHeader, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, TextField, Tooltip } from '@mui/material';
import moment from 'moment';
import { DataGrid, trTR } from '@mui/x-data-grid';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { getCampaignProductDynamic, insertCampaignProductDynamic, deleteCampaignProductDynamic } from 'src/store/slices/dynamicCatalogSlice';
import { getCustomerTypes } from 'src/store/slices/assigmentSlice';
import { getChangeReasons, getChangeReasonWithUp } from 'src/store/slices/commonSlice';
import { getUser } from 'src/utils/Common';
import AlertAndLoading from 'src/components/AlertAndLoading';
import {
  DARK,
  ORANGE,
  darkButtonSx,
  dialogPaperProps,
  inputSx,
  lightButtonSx,
  listboxProps,
  useDynamicStyles
} from 'src/components/dynamicCatalogStyles';
import DynamicListToolbar, { filterDynamicRows } from 'src/components/DynamicListToolbar';

const gridLocale = { ...trTR.components.MuiDataGrid.defaultProps.localeText, noRowsLabel: 'Kayıt bulunamadı.' };

function CampaignProductSkuDynamic() {
  const classes = useDynamicStyles();
  const dispatch = useDispatch();
  const SessionUser = getUser();

  const customerTypes = useSelector((state) => state.assigmentSlice.customerTypes);
  const changeReasonData = useSelector((state) => state.commonSlice.changeReasons);
  const upChangeData = useSelector((state) => state.commonSlice.upChangeReasons);
  const [changeReasonn, setChangeReasons] = React.useState(null);
  const [upChangeReason, setUpChangeReasons] = React.useState(null);
  const [campaignProduct, setCampaignProduct] = React.useState([]);
  const [campaignProductModelCode, setCampaignProductModelCode] = React.useState("");
  const [customerType, setCustomerType] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [detailLoading, setDetailLoading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [deleteTarget, setDeleteTarget] = React.useState(null);
  const [searchText, setSearchText] = React.useState('');
  const [responseMessage, setresponseMessage] = React.useState('');
  const [uyari, setUyari] = React.useState(false);
  const [alertType, setAlertType] = React.useState({ ErrorType: 'error', ErrorTitle: 'Uyarı' });

  const loadCampaignProducts = () => {
    setLoading(true);
    dispatch(getCampaignProductDynamic()).then(response => {
      // Son kayıt silindiğinde liste boş dönebilir; başarılı cevapta her zaman güncellenir
      if (response.meta?.requestStatus === 'fulfilled') {
        setCampaignProduct(Array.isArray(response.payload) ? response.payload : []);
      }
      setLoading(false);
    })
  };

  useEffect(() => {
    loadCampaignProducts();
    dispatch(getCustomerTypes());
    dispatch(getChangeReasons());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  function InfoAlert(ErrorDescription, ErrorType, ErrorTitle) {
    setresponseMessage(ErrorDescription);
    setAlertType({
      ErrorType: ErrorType,
      ErrorTitle: ErrorTitle
    })
    setUyari(true);
    return
  }

  // Değişim nedeni değişince detay seçimi sıfırlanır ve detay listesi yeniden yüklenir
  function changeReason(val) {
    setChangeReasons(val);
    setUpChangeReasons(null);
    if (val?.ChangeReason) {
      setDetailLoading(true);
      dispatch(getChangeReasonWithUp(val.ChangeReason)).then(() => {
        setDetailLoading(false);
      })
    }
  }

  function InsertCampaignProductClick() {
    if (!campaignProductModelCode.trim() || changeReasonn == null || customerType == null || upChangeReason?.ACIKLAMA == null) {
      InfoAlert('Lütfen Kutucukları Boş Bırakmayınız!...', 'error', 'Hata');
      return
    }

    const data = {
      ModelCode: campaignProductModelCode.trim(),
      CustomerType: customerType.Id,
      ExchangeReason: changeReasonn.ChangeReason,
      ExchangeReasonDetail: upChangeReason.DEGISIM_NEDENI,
      SicilNo: SessionUser?.UserId?.toString(),
    }

    setSaving(true);
    dispatch(insertCampaignProductDynamic(data)).then(response => {
      setSaving(false);
      // eslint-disable-next-line eqeqeq
      if (response.payload?.ErrorCode == 0) {
        InfoAlert(response.payload.ErrorDescription, 'success', 'Başarılı');
        setCampaignProductModelCode("");
        loadCampaignProducts();
      } else {
        InfoAlert(response.payload?.ErrorDescription || 'Kayıt eklenemedi.', 'error', 'Hata');
      }
    })
  }

  function deleteCampaignProductDynamicClick() {
    if (!deleteTarget) return;
    setSaving(true);
    dispatch(deleteCampaignProductDynamic([deleteTarget.ID])).then(response => {
      setSaving(false);
      setDeleteTarget(null);
      // eslint-disable-next-line eqeqeq
      if (response.payload?.ErrorCode == 0) {
        InfoAlert(response.payload.ErrorDescription, 'success', 'Başarılı');
        loadCampaignProducts();
      } else {
        InfoAlert(response.payload?.ErrorDescription || 'Kayıt silinemedi.', 'error', 'Hata');
      }
    })
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const filteredRows = useMemo(() => filterDynamicRows(campaignProduct, {
    searchText,
    searchFields: ['MODEL_CODE', 'CUSTOMER_TYPE', 'EXCHANGE_REASON', 'EXCHANGE_REASON_DETAIL', 'SICILNO']
  }), [campaignProduct, searchText]);

  const columns = [
    { field: 'MODEL_CODE', headerName: 'Model Kodu', flex: 1, minWidth: 130 },
    { field: 'CUSTOMER_TYPE', headerName: 'Müşteri Tipi', flex: 0.8, minWidth: 120 },
    { field: 'EXCHANGE_REASON', headerName: 'Değişim Nedeni', flex: 1.2, minWidth: 160 },
    { field: 'EXCHANGE_REASON_DETAIL', headerName: 'Değişim Nedeni Detay', flex: 1.2, minWidth: 160 },
    { field: 'SICILNO', headerName: 'Ekleyen Sicil No', width: 130 },
    {
      field: 'ADDED_DATE', headerName: 'Eklenme Tarihi', width: 120,
      valueFormatter: (p) => (p.value ? moment(p.value).format('DD.MM.YYYY') : '')
    },
    {
      field: 'Sil', headerName: 'İşlem', width: 80, align: 'center', headerAlign: 'center',
      sortable: false, filterable: false, disableColumnMenu: true,
      renderCell: (cellValues) => (
        <Tooltip title="Sil">
          <IconButton size="small" onClick={() => setDeleteTarget(cellValues.row)}>
            <DeleteOutlineIcon sx={{ fontSize: 18, color: '#e53935' }} />
          </IconButton>
        </Tooltip>
      )
    }
  ];

  const comboProps = {
    size: 'small',
    fullWidth: true,
    ListboxProps: listboxProps,
    noOptionsText: 'Seçenek yok'
  };

  const formIncomplete = !campaignProductModelCode.trim() || !customerType || !changeReasonn || !upChangeReason;

  return (
    <>
      <AlertAndLoading Message={responseMessage} open={uyari} AlertType={alertType} onClose={uyariKapat} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* Yeni kayıt */}
        <Card className={classes.card}>
          <CardHeader className={classes.cardHeader} title="Yeni Kampanya Model Kodu" />
          <Box sx={{ p: 2, opacity: saving ? 0.6 : 1, pointerEvents: saving ? 'none' : 'auto' }}>
            <Grid container spacing={1.5} alignItems="center">
              <Grid item xs={12} sm={6} lg={2.6}>
                <TextField
                  size="small"
                  fullWidth
                  sx={inputSx}
                  label="Kampanya Model Kodu"
                  value={campaignProductModelCode}
                  onChange={(e) => setCampaignProductModelCode(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={2.6}>
                <Autocomplete
                  {...comboProps}
                  options={customerTypes || []}
                  value={customerType}
                  getOptionLabel={(option) => option.Dsc || ''}
                  isOptionEqualToValue={(o, v) => o.Id === v.Id}
                  onChange={(event, newValue) => setCustomerType(newValue)}
                  renderInput={(params) => <TextField {...params} sx={inputSx} label="Müşteri Tipi" />}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={2.6}>
                <Autocomplete
                  {...comboProps}
                  options={changeReasonData || []}
                  value={changeReasonn}
                  getOptionLabel={(option) => option.Dsc || ''}
                  isOptionEqualToValue={(o, v) => o.ChangeReason === v.ChangeReason}
                  onChange={(event, val) => changeReason(val)}
                  renderInput={(params) => <TextField {...params} sx={inputSx} label="Değişim Nedeni" />}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={2.6}>
                <Autocomplete
                  {...comboProps}
                  options={changeReasonn ? (upChangeData || []) : []}
                  value={upChangeReason}
                  loading={detailLoading}
                  loadingText="Yükleniyor…"
                  disabled={!changeReasonn}
                  getOptionLabel={(option) => option.ACIKLAMA || ''}
                  isOptionEqualToValue={(o, v) => o.DEGISIM_NEDENI === v.DEGISIM_NEDENI}
                  onChange={(event, val) => setUpChangeReasons(val)}
                  renderInput={(params) => <TextField {...params} sx={inputSx} label="Değişim Nedeni Detay" />}
                />
              </Grid>
              <Grid item xs={12} lg={1.6}>
                <Button
                  fullWidth
                  startIcon={saving && !deleteTarget ? <CircularProgress size={14} sx={{ color: ORANGE }} /> : <AddIcon />}
                  sx={darkButtonSx}
                  disabled={saving || formIncomplete}
                  onClick={InsertCampaignProductClick}
                >
                  Ekle
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Card>

        {/* Liste */}
        <Card className={classes.card}>
          <CardHeader
            className={classes.cardHeader}
            title="Kampanya Model Kodları"
            subheader={loading ? 'Yükleniyor…' : `${campaignProduct.length} kayıt`}
          />
          <DynamicListToolbar
            searchText={searchText}
            onSearchChange={setSearchText}
            placeholder="Model kodu, neden veya sicil ara"
            shownCount={filteredRows.length}
          />
          <DataGrid
            className={classes.grid}
            style={{ height: 480, width: '100%' }}
            rows={filteredRows}
            columns={columns}
            loading={loading}
            rowHeight={44}
            headerHeight={44}
            disableSelectionOnClick
            getRowId={(row) => row.ID}
            localeText={gridLocale}
          />
        </Card>
      </Box>

      {/* Silme onayı */}
      <Dialog open={!!deleteTarget} onClose={() => !saving && setDeleteTarget(null)} fullWidth maxWidth="xs" PaperProps={dialogPaperProps}>
        <DialogTitle className={classes.dialogTitle}>
          Kayıt Sil
          <IconButton size="small" onClick={() => setDeleteTarget(null)} disabled={saving}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: '16px !important' }}>
          <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
            <WarningAmberIcon sx={{ color: ORANGE, mt: '2px' }} />
            <Box sx={{ fontSize: '13px', color: DARK }}>
              <b>{deleteTarget?.MODEL_CODE}</b> kaydı silinecek. Emin misiniz?
              <Box sx={{ mt: 1.5, p: '8px 12px', borderRadius: '10px', backgroundColor: '#fafafa', border: '1px solid #e0e0e0', fontSize: '12px', lineHeight: 1.7 }}>
                <div>{deleteTarget?.CUSTOMER_TYPE}</div>
                <div>{deleteTarget?.EXCHANGE_REASON} › {deleteTarget?.EXCHANGE_REASON_DETAIL}</div>
              </Box>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button sx={lightButtonSx} onClick={() => setDeleteTarget(null)} disabled={saving}>Vazgeç</Button>
          <Button
            sx={{ ...darkButtonSx, minWidth: 90, color: '#fff', backgroundColor: '#e53935', '&:hover': { backgroundColor: '#c62828' } }}
            onClick={deleteCampaignProductDynamicClick}
            disabled={saving}
            startIcon={saving ? <CircularProgress size={14} sx={{ color: '#fff' }} /> : null}
          >
            Sil
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CampaignProductSkuDynamic;
